import { ref } from 'vue'

const query = window.matchMedia('(pointer: coarse)')
const coarse = ref(query.matches)
query.addEventListener('change', (event) => (coarse.value = event.matches))

export default function useCoarsePointer() {
  return coarse
}
